var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{ref:"watermark",staticClass:"watermark"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }